// Inquiry API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { INQUIRIES } = API_ENDPOINTS;

export const inquiryApi = {
  /** GET /admin/inquiries/ — accepts { period, date_from, date_to, status, salesperson_id } */
  getList: (params = {}) => axiosInstance.get(INQUIRIES.LIST, { params }),

  /** GET /admin/inquiries/{id}/ */
  getDetail: (id) => axiosInstance.get(INQUIRIES.DETAIL(id)),

  /** GET /admin/inquiries/day/ — the inquiries that CAME IN over a window,
   *  with their parts, the salesperson who took them and every supervisor
   *  who priced them.
   *  { period, from, to, salespersonId, q, sort: 'value'|'recent', page, pageSize }
   *  Passing from/to overrides period, exactly as the backend expects. */
  getDay: ({
    period = 'today', from, to, salespersonId, q = '',
    sort = 'value', page = 1, pageSize = 25,
  } = {}) =>
    axiosInstance.get(INQUIRIES.DAY, {
      params: {
        period: from || to ? undefined : period,
        from: from || undefined,
        to: to || undefined,
        salesperson_id: salespersonId || undefined,
        q: q || undefined,
        sort,
        page,
        page_size: pageSize,
      },
    }),

  /** POST /admin/inquiries/{id}/follow-ups/ — the same trail the salesperson
   *  writes, from the review chair. { outcome, note, next_follow_up_at? } */
  addFollowUp: (id, data) => axiosInstance.post(INQUIRIES.FOLLOW_UPS(id), data),

  /** GET the follow-up trail for one inquiry. */
  getFollowUps: (id) => axiosInstance.get(INQUIRIES.FOLLOW_UPS(id)),

  /** POST /admin/inquiries/{id}/close/ — mark it LOST, reason required. */
  closeInquiry: (id, reason) => axiosInstance.post(INQUIRIES.CLOSE(id), { reason }),
};
